import axios from 'axios'
import { storage } from '../../../helpers'
import { API_URL } from '../../../config'

export const exportPartnerIbansRequest = async ({
  partnerCifs = null,
  partnerGroups = null,
  worldClassCifs = null,
  searchTerm = null
}) => {
  const token = storage.getToken()

  const response = await axios.post(
    `${API_URL}/v2/nomenclatures/partners/ibans/export`,
    { partnerCifs, partnerGroups, worldClassCifs, searchTerm },
    {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${token}`
      }
    }
  )

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })

  const contentDisposition = response.headers['content-disposition']
  const fileNameMatch = contentDisposition?.match(/filename="(.+?)"/)
  const fileName = fileNameMatch ? fileNameMatch[1] : 'parteneri_iban.xlsx'

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  window.URL.revokeObjectURL(url)
}
